import { render, staticRenderFns } from "./add.vue?vue&type=template&id=5b5aa616&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=5b5aa616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5aa616",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/nuxt-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b5aa616')) {
      api.createRecord('5b5aa616', component.options)
    } else {
      api.reload('5b5aa616', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=5b5aa616&scoped=true&", function () {
      api.rerender('5b5aa616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/popups/marques/add.vue"
export default component.exports